import { ProductType, RBTechnical } from 'store/railsBuilder/reducer.types';
import { Entitlement } from 'store/user/reducer.types';

import getProductsNotInEntitlements from 'screens/Detail/utils/getProductsNotInEntitlements';
import { getTransactionProducts } from 'screens/Detail/utils/getTransactionProducts';

export function getPurchasableProducts(
    technical: RBTechnical | undefined,
    productType: ProductType,
    entitlements: Entitlement[],
) {
    const filteredProducts = getTransactionProducts(technical, productType);

    if (!filteredProducts?.length) {
        return [];
    }

    return getProductsNotInEntitlements(filteredProducts, entitlements);
}
